import { createPipe } from 'remeda';
import replace from './replace';
import trim from './trim';
import join from './join';
var formatString = createPipe(replace(/[\t\n\r]+/g, ' '), replace(/  +/g, ' '), trim);
var formatArray = createPipe(join(' '), formatString);
var collapse = function (input) {
    if (Array.isArray(input)) {
        return formatArray(input);
    }
    return formatString(input);
};
export default collapse;
